export enum ErrorCodes {
  JOIN_FAIL_NO_SUCH_USER = 'JOIN_FAIL_NO_SUCH_USER',
  JOIN_ALREADY_MEMBER = 'JOIN_ALREADY_MEMBER',
  UNKNOWN_ROOM = 'UNKNOWN_ROOM',
  UNAUTHORIZED_USER = 'UNAUTHORIZED_USER',
  UNAUTHORIZED_ROOM_ACCESS = 'UNAUTHORIZED_ROOM_ACCESS',
  INCORRECT_ROOM_PASSCODE = 'INCORRECT_ROOM_PASSCODE',
  INVALID_USER_IDENTITY = 'INVALID_USER_IDENTITY',
  LINK_EXPIRED = 'LINK_EXPIRED',
  PAGE_NOT_FOUND = 'PAGE_NOT_FOUND',
  ROOM_NOT_FOUND = 'ROOM_NOT_FOUND',
  UNEXPECTED = 'UNEXPECTED',
  TOO_MANY_OWNED_ROOMS = 'TOO_MANY_OWNED_ROOMS',
  ALREADY_INVITED = 'ALREADY_INVITED',
  CLAIM_UNIQUENESS = 'CLAIM_UNIQUENESS',
  CANT_INVITE_SELF = 'CANT_INVITE_SELF',
  INVALID_ROOM_CLAIM = 'INVALID_ROOM_CLAIM',
  ALREADY_CLAIMED = 'ALREADY_CLAIMED',
  INVALID_INVITE = 'INVALID_INVITE',
  TOO_MANY_INVITES = 'TOO_MANY_INVITES',
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  ADMIN_ONLY_RESTRICTED = 'ADMIN_ONLY_RESTRICTED',
  NO_SUCH_USER = 'NO_SUCH_USER',
  INVALID_OTP = 'INVALID_OTP',
  EXPIRED_OTP = 'EXPIRED_OTP',
  RESOLVED_OTP = 'RESOLVED_OTP',
  INVALID_ACTION = 'INVALID_ACTION',
  ALREADY_LOGGED_IN = '',
  INVALID_LINK = 'INVALID_LINK',
  EXPIRED_TOKEN = 'EXPIRED_TOKEN',
  JOIN_ROOM_LINK_EXPIRED = 'JOIN_ROOM_LINK_EXPIRED',
  CLAIM_LINK_EXPIRED = 'CLAIM_LINK_EXPIRED',
  JOIN_ROOM_UNKNOWN = 'JOIN_ROOM_UNKNOWN',
  NO_ROOM_PASSWORD = 'NO_ROOM_PASSWORD',
  INVALID_API_PARAMS = 'INVALID_API_PARAMS',
  REVOKED_OTP = 'REVOKED_OTP',
  TOO_MANY_ROOM_MEMBERS = 'TOO_MANY_ROOM_MEMBERS',
  // display only error codes
  INVITE_EXPIRED = 'INVITE_EXPIRED',
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
}
